import { FC } from "react";
import { Route, Switch } from "react-router-dom";
import HomeScreen from "@views/home/HomeScreen";
import "./styles/styles.scss";
import "./utils/i18n/i18n";
import ComponentsScreen from "@views/components/ComponentsScreen";
import ToastAlert from "@components/alerts/ToastAlert";
import {
  ACCESSIBILITY_ROUTE,
  COLLECTIVITY_ROUTE,
  COMPONENTS_ROUTE,
  COOKIE_ROUTE,
  FARMER_ROUTE,
  HOME_ROUTE,
  TERMS_OF_USE_ROUTE,
} from "@utils/Routes";
import CookiesScreen from "@views/footer/CookiesScreen";
import FarmerScreen from "@views/farmer/FarmerScreen";
import CollectivityScreen from "@views/collectivity/CollectivityScreen";
import AccessibilityScreen from "@views/footer/AccessibilityScreen";
import TermsOfUseScreen from "@views/footer/TermsOfUseScreen";

export const App: FC = () => {
  return (
    <div className="global">
      {/*{configuration.environment !== "production" && <AppInfosRibbon />}*/}
      <ToastAlert />
      <Switch>
        <Route exact path={COMPONENTS_ROUTE} component={ComponentsScreen} />

        <Route exact path={COOKIE_ROUTE} component={CookiesScreen} />
        <Route
          exact
          path={ACCESSIBILITY_ROUTE}
          component={AccessibilityScreen}
        />
        <Route exact path={TERMS_OF_USE_ROUTE} component={TermsOfUseScreen} />

        <Route exact path={HOME_ROUTE} component={HomeScreen} />

        <Route exact path={FARMER_ROUTE} component={FarmerScreen} />
        <Route exact path={COLLECTIVITY_ROUTE} component={CollectivityScreen} />
      </Switch>
    </div>
  );
};

export default App;
